// UI identity only. This does not authorize a read, generation or Gmail write.
// Retain the selected six-field tuple exactly; never silently choose newer art.
export const COMPOSE_PROOF_FIELDS = Object.freeze(['workspaceJobId','championshipId','engineRevision','outputAssetId','sha256','specFingerprint'])
const text=value=>typeof value==='string'&&value.length>0&&value.length<=256&&!/[\s\x00-\x1f\x7f]/.test(value) // eslint-disable-line no-control-regex
const hash=value=>typeof value==='string'&&/^[a-f0-9]{64}$/.test(value)
export function selectedComposeProof(value) {
  if(!value||!['workspaceJobId','championshipId','outputAssetId'].every(key=>text(value[key]))||!Number.isSafeInteger(value.engineRevision)||value.engineRevision<1||!hash(value.sha256)||!hash(value.specFingerprint))return null
  return Object.freeze(Object.fromEntries(COMPOSE_PROOF_FIELDS.map(key=>[key,value[key]])))
}
export function sameComposeProof(actual,expected) {
  return Boolean(selectedComposeProof(actual)&&selectedComposeProof(expected)&&COMPOSE_PROOF_FIELDS.every(key=>actual[key]===expected[key]))
}
export function composeProofIdentity(proof) {
  const selected=selectedComposeProof(proof)
  return selected?JSON.stringify(COMPOSE_PROOF_FIELDS.map(key=>selected[key])):null
}
export function composeProofFromJob(job) {
  if(job?.deletedAt!==undefined&&job?.deletedAt!==null)return null
  const engine=job?.artworkEngine,outputs=(job?.assets||[]).filter(asset=>asset.id===engine?.outputAssetId)
  if(outputs.length!==1)return null
  const output=outputs[0]
  if(output.role!=='artwork_engine_output'||output.engineRevision!==engine?.revision||output.specFingerprint!==undefined&&output.specFingerprint!==engine?.specFingerprint)return null
  return selectedComposeProof({workspaceJobId:job.id,championshipId:job.championshipId,engineRevision:engine?.revision,outputAssetId:output.id,sha256:output.sha256,specFingerprint:engine?.specFingerprint})
}
export function composeProofQuery(proof) {
  const selected=selectedComposeProof(proof)
  if(!selected)throw Error('The exact saved artwork selection is unavailable. Reopen the original artwork; no replacement was selected.')
  return {...selected}
}
